import { AvatarDirectory } from './avatarDirectory';
import usePeopleDirectory from './usePeopleDirectory';

/**
 * The organization's profile pictures, fetched once for a whole list.
 *
 * One request per page, not one per row: `ProfileImage` already deduplicates
 * the actual image fetches through its module-level cache, so the only thing
 * a list needs is the URLs.
 *
 * Never throws and never blocks: a failed or slow directory leaves the rows on
 * their existing Gravatar-then-initials fallback, which is what they showed
 * before. A picture arriving a moment after the names is the right trade.
 *
 * The pictures are one half of what `/org-people/people` carries — the uuids
 * are the other — so the fetch itself lives in `usePeopleDirectory` and this is
 * the view of it that callers who only want faces can keep asking for.
 */
const useAvatarDirectory = (): AvatarDirectory => usePeopleDirectory().directory.avatars;

export default useAvatarDirectory;
